import { Skeleton } from '@/components/skeleton/skeleton'

import { cn } from '@/lib/utils'

export const Loading = () => {
  return (
    <div className={cn('space-y-4', 'p-6')}>
      <Skeleton className={cn('h-10', 'rounded-md')} />
      <Skeleton className={cn('h-12', 'rounded-md')} />
    </div>
  )
}
